// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const durant: PokeData = {
  "id": 632,
  "name": "durant",
  "height": 3,
  "weight": 330,
  "base_experience": 169,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "sand-attack",
    "bite",
    "dig",
    "agility",
    "fury-cutter",
    "metal-claw",
    "crunch",
    "beat-up",
    "metal-sound",
    "iron-defense",
    "x-scissor",
    "iron-head",
    "bug-bite",
    "entrainment"
  ],
  "moves": [
    "bite",
    "metal-claw",
    "crunch",
    "metal-sound",
    "bug-bite",
    "signal-spam",
    "lunge",
    "meteor-mash",
    "infest",
    "bug-buzz",
    "pin-rush",
    "sticky-web",
    "heal-order"
  ],
  "evolution_chain": {
    "id": 322,
    "item": null,
    "species": [
      {
        "name": "durant",
        "order": 633,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 152,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
